import { render } from "./pb-meriteconseil.vue?vue&type=template&id=1228ede2"
import script from "./pb-meriteconseil.vue?vue&type=script&lang=js"
export * from "./pb-meriteconseil.vue?vue&type=script&lang=js"

import "./pb-meriteconseil.vue?vue&type=style&index=0&id=1228ede2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__